import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../utils/constants';

const ProductCard = ({ product, classes }) => {
  const image = product.images.length > 0 ? `${API_BASE_URL}/uploads/${product.images[0].filename}` : product.image_url;
  return (
    <Link to={`/product/${product.id}`} className={`border rounded shadow p-4 text-center hover:shadow-md transition ${classes}`}>
      {image ? (
        <img
          src={image}
          alt={product.subname || product.product_name || 'Proizvod'}
          loading="lazy"
          decoding="async"          // hint to browser to decode off main thread
          fetchpriority="low"      // Chrome hint: these are not critical like above-the-fold hero image
          className="w-full h-48 object-contain mb-2"
        />
      ) : (
        <div className="w-full h-48 flex items-center justify-center bg-gray-100 text-sm text-gray-500 mb-2">
          No Image
        </div>
      )}
      <h3 className="font-semibold">{product.subname ? product.subname : product.product_name}</h3>
      <p className="text-sm text-gray-700">{parseFloat(product.price).toFixed(2)} rsd</p>
    </Link>
  );
};

export default ProductCard;
